import * as React from 'react';
import { Box, IconButton, Popover, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
var OcrCheckmarkIcon = function () { return (React.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none" },
    React.createElement("path", { d: "M1 5L4.5 8.5L11 1.5", stroke: "#fff", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
var BANNER_SX = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    px: 2,
    py: 0.5,
    mb: 2,
    borderRadius: '4px',
    bgcolor: '#A1E3CD33',
};
var CHECK_DISC_SX = {
    width: 18,
    height: 18,
    borderRadius: '50%',
    bgcolor: '#064A35',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};
var POPOVER_PAPER_SX = {
    borderRadius: '10px',
    boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
    border: '1px solid #E5E7EB',
    minWidth: 180,
    p: 0,
    overflow: 'hidden',
};
var OcrExtractionBanner = function (_a) {
    var extractedCount = _a.extractedCount, documentLabels = _a.documentLabels, fieldLabels = _a.fieldLabels;
    var _b = React.useState(null), anchorElement = _b[0], setAnchorElement = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: BANNER_SX },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1.5 },
                React.createElement(Box, { sx: CHECK_DISC_SX },
                    React.createElement(OcrCheckmarkIcon, null)),
                React.createElement(Typography, { fontSize: "14px", lineHeight: 1.4, color: "#064A35" },
                    React.createElement(Box, { component: "span", fontWeight: 700 },
                        extractedCount,
                        " Fields Extracted",
                        ' '),
                    "from ",
                    documentLabels)),
            React.createElement(IconButton, { size: "small", "aria-label": "Extracted field names", sx: { color: '#064A35', p: '2px', flexShrink: 0 }, onClick: function (event) { return setAnchorElement(event.currentTarget); } },
                React.createElement(InfoOutlinedIcon, { sx: { fontSize: 18 } }))),
        React.createElement(Popover, { open: Boolean(anchorElement), anchorEl: anchorElement, onClose: function () { return setAnchorElement(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, PaperProps: { sx: POPOVER_PAPER_SX } },
            React.createElement(Typography, { fontSize: "13px", fontWeight: 700, color: "#000000", sx: { px: 2, py: 1.5 } }, "Extracted Field Names"),
            React.createElement(Box, { sx: { px: 2, pb: 1.5, maxHeight: 240, overflowY: 'auto' } }, fieldLabels.map(function (label) { return (React.createElement(Typography, { key: label, fontSize: "13px", color: "#000000", sx: { py: 0.8 } }, label)); })))));
};
export default React.memo(OcrExtractionBanner);
